<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <main class="mx-auto flex max-w-xl flex-col gap-4 p-8">
    <h1 class="text-[length:var(--text-step-6)] font-semibold text-[color:var(--color-text)]">
      {{ t('auth.notProvisionedTitle') }}
    </h1>
    <p class="text-[color:var(--color-text-muted)]">{{ t('auth.notProvisionedBody') }}</p>
  </main>
</template>
